import { render, staticRenderFns } from "./ManterTipoCreditoAssuntoExibir.vue?vue&type=template&id=31bd8185&scoped=true&"
import script from "./ManterTipoCreditoAssuntoExibir.vue?vue&type=script&lang=js&"
export * from "./ManterTipoCreditoAssuntoExibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd8185",
  null
  
)

export default component.exports